import React from "react";
import { Content } from "../../pages/Template";
import { Tag } from "../../models";
import { NoResults, Results } from "../../components/Results";
import { Book } from "../../components";
import { navigate } from "../../services";
import { DocMeta, docUrl, setWindowTitle } from "../../helpers";
import Tags from "../../components/Tags";
import { AxiosResponse } from "axios";

function tagId(props: Props) {
    return parseInt(props.match.params.tag_id);
}

function tagName(props: Props) {
    return props.match.params.tag_name.replace("-", " ");
}

type Props = {
    match: {
        params: {
            tag_id: string;
            tag_name: string;
        };
    };
};
interface TagBook {
    id: number;
    name: string;
    updated_at: string;
    doc_meta: Array<DocMeta>;
}
type State = {
    list: Array<TagBook>;
    stats: {
        offset: number;
        limit: number;
        total: number;
    };
};
export class TagPage extends React.Component<Props, State> {
    static paths = ["/app/t-:tag_id-:tag_name"];

    constructor(props: Props) {
        super(props);
        this.state = {
            list: [],
            stats: {
                offset: 0,
                limit: 0,
                total: 0,
            },
        };
    }

    async componentDidMount() {
        setWindowTitle(tagName(this.props));
        await this.fetch(tagId(this.props));
    }

    async componentDidUpdate(
        prevProps: Props,
        prevState: State,
        snapshot: any
    ) {
        if (tagId(this.props) !== tagId(prevProps)) {
            await this.fetch(tagId(this.props));
            setWindowTitle(tagName(this.props));
        }
    }

    loading = false;
    async fetch(tagId: number, concat = false) {
        if (this.loading) {
            return;
        }

        this.loading = true;

        try {
            const { offset, limit } = this.state.stats;
            const params = [
                "includeMeta=true",
                "includesPages=false",
                `tag_id=${tagId}`,
                `offset=${concat ? offset + limit : 0}`,
            ];
            const {
                data: { list, stats },
            }: AxiosResponse<{
                list: Array<TagBook>;
                stats: {
                    offset: number;
                    limit: number;
                    total: number;
                };
            }> = await Tag.fetch("books", {
                url: params.join("&"),
            });

            this.setState({
                stats,
                list: concat ? this.state.list.concat(list) : list,
            });
            this.loading = false;
        } catch (e) {
            console.warn(e);
        }
    }

    onMore = async () => {
        await this.fetch(tagId(this.props), true);
    };

    render() {
        const { list, stats } = this.state;
        if (list.length === 0) {
            return <NoResults message="results.tagsNone" />;
        }

        const enableMore = stats.total > stats.offset + stats.limit;
        return (
            <Content>
                <Tags marginTop={23} />
                <Results
                    stats={stats}
                    onMore={this.onMore}
                    enableMore={enableMore}
                >
                    {list.map((item) => (
                        <Book
                            {...item}
                            width={220}
                            key={`book-${item.id}`}
                            onClick={() => navigate.to(docUrl(item))}
                        />
                    ))}
                </Results>
            </Content>
        );
    }
}
